import axios from 'axios';
import config from 'api/urls-config.json';

export const getCropNutrition = params => {
    return axios.get(`${config.API + config.pages.crop_nutrition_programs}`, { params });
};

export const getCropNutritionDetail = params => {
    const { slug, language, country } = params;

    return axios.get(`${config.API + config.pages.crop_nutrition_programs_slug + slug}`, {
        params: {
            language,
            country,
        },
    });
};

export const getCropsForProductByTypeAndTrialsCountry = params => {
    const { slug, language, country, trials_country, type, page = 1, limit = 1 } = params;
    // add pagination
    // all for filters
    return axios.get(`${config.API + config.crops}`, {
        params: {
            language,
            country,
            product: slug,
            trials_country,
            type,
            page,
            limit,
        },
    });
};
